import { createTheme } from "@mui/material/styles";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/outfit/800.css";

// Brand: #002B1B, #004225, #A7B8A5, #C3A56A, #F4EFE5, #63345F. Soleil + Proxima Nova.
const bodyFont = '"proxima-nova","Proxima Nova","Figtree",system-ui,sans-serif';
const displayFont = '"soleil","Soleil","Outfit",system-ui,sans-serif';

const theme = createTheme({
    palette: {
        primary: {
            main: '#004225',
            dark: '#002B1B',
            light: '#A7B8A5',
            contrastText: '#F4EFE5',
        },
        secondary: {
            main: '#C3A56A',
            contrastText: '#002B1B',
        },
        background: {
            default: '#F4EFE5',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#10251C',
        },
    },
    typography: {
        fontFamily: bodyFont,
        h1: { fontFamily: displayFont },
        h2: { fontFamily: displayFont },
        h3: { fontFamily: displayFont },
        h4: { fontFamily: displayFont },
        h5: { fontFamily: displayFont },
        h6: { fontFamily: displayFont },
        button: {
            textTransform: 'none'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 2000,
        },
    },
});

export default theme;